module.exports = __webpack_public_path__ + "img/katarina_amenities_6.f48baccc.jpg";